module.exports = __webpack_public_path__ + "static/media/TunnelShedHouse.0e8552d4.png";